var map = {
	"./africa/home.vue": [
		"KDUc",
		23
	],
	"./club-soft/home.vue": [
		"9a4i",
		22
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "gcDM";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/pages/home lazy ^\.\/.*\/home\.vue$
// module id = gcDM
// module chunks = 37